export const SUBSCRIPTIONS_EMPTY_NAME = 'Без названия';
export const SUBSCRIPTIONS_UNLIMITED_PERIOD = 'Бессрочно';

// Сумма ширин колонок (240 + 240 + 160 + 160 + 100) плюс ~8% запаса
export const SUBSCRIPTIONS_TABLE_SCROLL_X = 980;
